import { FC } from 'react';
import { X } from 'lucide-react';
import { useAuth } from "@/hooks/useAuth";
import { useNavigate } from 'react-router-dom';
import {
  Sidebar,
  SidebarContent,
  SidebarGroup,
  SidebarGroupLabel,
  SidebarGroupContent,
  useSidebar,
} from "@/components/ui/sidebar";
import { SidebarNavigation } from './sidebar/SidebarNavigation';
import { SidebarFooter } from './sidebar/SidebarFooter';

export const AppSidebar: FC = () => {
  const { toggleSidebar, setOpenMobile, isMobile } = useSidebar();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
      navigate('/login');
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  return (
    <Sidebar className="z-50">
      <SidebarContent className="bg-white md:bg-gradient-to-b md:from-primary/10 md:to-accent/5 bg-white/95 backdrop-blur-sm">
        <div className="flex items-center justify-between p-2 md:hidden">
          <button
            onClick={toggleSidebar}
            className="p-1.5 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Cerrar menú"
          >
            <X className="h-5 w-5 text-gray-600" />
          </button>
        </div>
        <SidebarGroup>
          <SidebarGroupLabel className="text-lg font-bold text-primary mb-4">
            Navegación
          </SidebarGroupLabel>
          <SidebarGroupContent>
            <SidebarNavigation 
              isMobile={isMobile}
              setOpenMobile={setOpenMobile}
              onSignOut={handleSignOut}
            />
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter />
    </Sidebar>
  );
};